'use strict';

export const handleImageContainerClick = (element = '.js-image-container') => {
    const imageElements = document.querySelectorAll(element);
    if (!imageElements || imageElements.length === 0) return;

    imageElements.forEach(image => {
        const imageURL = image.dataset.url;

        if (!imageURL || imageURL === '#') return;

        // eslint-disable-next-line no-param-reassign
        image.style.cursor = 'pointer';
        image.addEventListener('click', (e) => {
            e.stopPropagation();
            window.location.href = imageURL;
        });
    });
};
